import type { ReactNode, JSX } from "react";
import ProductRowList from "@components/commerce/product/list/product-row-list/ProductRowList";
import { styles } from "./AccordionBagListStyles";
import {
    Accordion,
    AccordionButton,
    AccordionItem,
    AccordionPanel,
    AccordionIcon,
} from "@ecco/ui/accordion";
import { Text } from "@ecco/ui/text";
import { Divider } from "@ecco/ui/divider";

interface Props {
    productsList: any[];
    locale: string;
    headerText: string;
    totalQuantity: number;
    children?: ReactNode;
}

export const accordionSmallShoppingBag = "accordion-bag-list";
export const headerTextId = "header-text";
export const arrowIcon = "arrow-icon";
export const expandedPanel = "expanded-panel";

const AccordionBagList = ({
    productsList,
    locale,
    headerText,
    totalQuantity,
    children,
}: Props): JSX.Element => {
    return (
        <Accordion sx={styles.container} data-testid={accordionSmallShoppingBag} allowToggle>
            <AccordionItem>
                {({ isExpanded }) => (
                    <>
                        <AccordionButton sx={styles.button}>
                            <Text
                                fontWeight={"bold"}
                                textTransform="uppercase"
                                data-testid={headerTextId}
                            >
                                {headerText} ({totalQuantity})
                            </Text>
                            <AccordionIcon data-testid={arrowIcon} />
                        </AccordionButton>
                        <AccordionPanel sx={styles.panel} data-testid={expandedPanel}>
                            {isExpanded && (
                                <>
                                    <ProductRowList items={productsList} locale={locale} />
                                    <Divider
                                        position={"absolute"}
                                        left={0}
                                        right={0}
                                        borderColor="gray.50"
                                    />
                                    {children}
                                </>
                            )}
                        </AccordionPanel>
                    </>
                )}
            </AccordionItem>
        </Accordion>
    );
};

export default AccordionBagList;
